import DPIncUtils from '../../../../includes/assets/js/modules/DPIncUtils';

export default class DPUserVisitCounter {
	static processVisit(mainCfg) {
		DPUserVisitCounter._processVisit(mainCfg, 'dp_intro_tours.visited_urls');
		if (mainCfg.currentUserId != 0) DPUserVisitCounter._processVisit(mainCfg, 'dp_intro_tours.visited_urls_logged_in');
	}

	static _processVisit(mainCfg, vclsid) {
		const visitedData = DPUserVisitCounter._getVisitCount(vclsid);
		visitedData.obj[visitedData.url] = visitedData.count + 1;
		if (mainCfg.dpDebugEn) console.log('DPUserVisitCounter', visitedData.url, visitedData.count + 1);
		localStorage.setItem(vclsid, JSON.stringify(visitedData.obj));
	}

	static _getVisitCountLocaleStorageId(mainCfg, allow_just_for_logged_in_users) {
		return mainCfg.currentUserId != 0 && allow_just_for_logged_in_users ? 'dp_intro_tours.visited_urls_logged_in' : 'dp_intro_tours.visited_urls';
	}

	static _getVisitCount(vclsid) {
		const currentUrl = new URL(window.location);
		const currentUrlUnified = DPIncUtils.unifyUrl(currentUrl.pathname);
		const visitedJSON = localStorage.getItem(vclsid);
		let visitedObj = {};
		if (visitedJSON && isNaN(visitedJSON)) {
			try {
				visitedObj = JSON.parse(visitedJSON) || {};
			} catch (exc) {
				console.error(exc);
			}
		}
		let visitedThisPage = parseInt(visitedObj[currentUrlUnified]);

		if (isNaN(visitedThisPage)) {
			visitedThisPage = 0;
		}
		return { count: visitedThisPage, obj: visitedObj, url: currentUrlUnified };
	}

	static getVisitCount(mainCfg, allow_just_for_logged_in_users) {
		if (mainCfg.currentUserId != 0 && allow_just_for_logged_in_users) {
			// server based data
			const visitedThisPage = parseInt(mainCfg.loggedInVisitCnt);
			return isNaN(visitedThisPage) ? 0 : visitedThisPage;
		}

		// local storage based data
		const vclsid = DPUserVisitCounter._getVisitCountLocaleStorageId(mainCfg, allow_just_for_logged_in_users);
		return DPUserVisitCounter._getVisitCount(vclsid).count;
	}
}
